<template>
  <div>
    <div class="main-container">
      <div class="announcement-content-wrap">
        <!--右侧内容 start-->
        <!--        <div class="right-content-wrap relative-position">-->
        <div class="left-content" :class="{'no-data': list.length === 0}">
          <ol class="announcement-list">
            <li class="announcement-item"
                v-for="item in list"
                :key="item.id"
                @click="$router.push({name: 'announcement-detail', query: {group: item.group, category: item.category, id: item.id}})"
            >
              <div class="announcement-left-img">
                <img :data-src="item.img" class="queue-load-img" v-if="item.img && showImg" @load.once="imgLoadEvent" @error.once="imgLoadEvent" alt="">
                <div class="no-img" v-else>IMG</div>
              </div>
              <div class="announcement-right-content" :class="{'announcement-right-content-mobile': $vuetify.breakpoint.xsOnly}">
                <span class="announcement-time">{{$t('labels.postDate')}} {{setTimeZone(item.created)}}</span>
                <h5 class="announcement-title">{{item.title}}</h5>
                <p class="announcement-brief-introduction">{{item.description}}</p>
              </div>
            </li>
          </ol>
          <div class="row justify-center">
            <v-pagination class="custome-pagination" v-model="pageData.current" :length="pageData.maxPages" @input="paginationChange"></v-pagination>
            <!--<q-pagination
              class="custome-pagination"
              :value="pageData.current"
              :min="pageData.minPages"
              :max="pageData.maxPages"
              :max-pages="6"
              :direction-links="true"
              @change="paginationChange"></q-pagination>-->
          </div>
        </div>
        <!--<div class="right-content">
          <div class="right-content-title">Sign up for our newsletter</div>
          <div class="right-content-sub-title">Be there when our newsletter drops.</div>
          <div class="right-content-input"><input type="text" placeholder="Email address"></div>
          <div class="right-content-btn">Subcribe Now</div>
        </div>-->
        <!--<q-inner-loading :visible="loading">
          <q-spinner-tail size="50px" color="primary"></q-spinner-tail>
          <span class="color-primary mt-10">数据加载中...</span>
        </q-inner-loading>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { articleApi } from '../../../api/announcement/article.module';
  import { getterTypes } from '../../../store/getter-types';

  export default {
    name: 'AnnouncementList',
    data () {
      let query = this.$route.query;
      return {
        // 控制移动端左侧菜单
        // leftDrawerShow: false,
        // 文章列表
        list: [],
        // 分页数据
        pageData: {
          current: query.current * 1 || 1,
          minPages: 1,
          maxPages: 1,
          pageSize: query.pageSize * 1 || 10,
        },
        firstLoad: true,
        loading: true,
        // 文章分类列表
        categoryList: [],
        // 文章分类
        category: query.category || 'PLATFORM_ANNOUNCEMENT',
        sliderMenuId: 'announcement',
        showImg: false,
        imgTotal: 0, // 图片总数量
        loadedImgCount: 0, // 已经加载完成的图片数量
        loadImgSize: 3, // 每次加载图片的数量
        loadImgCount: 0, // 手动加载图片的次数，相当于分页时的当前页
      };
    },
    methods: {
      getNoticeList () {
        let pageData = this.pageData;
        let formdata = {
          category: null, // 平台公告
          pageSize: pageData.pageSize,
          current: pageData.current,
        };
        this.loading = true;
        // if (params.category !== 'notice') {
        //   // formdata.group = 'article_research';
        // }
        this.loadedImgCount = 0;
        this.loadImgSize = 1;
        this.loadImgCount = 0;
        this.imgTotal = 0;
        articleApi.getArticleList(formdata)
          .then((res) => {
            let data = res.data;
            this.firstLoad = false;
            this.handleDescription(data.records);
            data.records.forEach(item => {
              if (item.img) {
                this.imgTotal++;
              }
            });
            // this.sort(data.records);
            this.list = data.records;
            pageData.totalItem = (data.total * 1) || 1;
            pageData.maxPages = data.pages;
            this.loading = false;
            this.loadImg();
            this.forceLoadImg();
            // pageData.current = data.current;
          });
      },
      // 处理简介
      handleDescription (list) {
        if (list.length === 0) { return list; }
        list.forEach(item => {
          let div = document.createElement('div');
          div.innerHTML = item.content;
          const onlyText = div.innerText || div.textContent;
          div = null;
          if (onlyText.length >= 200) {
            item.description = onlyText.substr(0, 197) + '...';
          } else {
            item.description = onlyText;
          }
        });
        return list;
      },
      // 分页点击事件
      paginationChange (current) {
        this.pageData.current = current;
        this.getNoticeList();
      },
      leftDrawerMenuClick () {
        this.leftDrawerShow = false;
      },
      // 加载图片
      loadImg () {
        // if(this.loadedImgCount === ){}
        this.$nextTick(() => {
          let start = this.loadedImgCount === 0 ? 0 : (this.imgTotal - this.loadedImgCount);
          let end = start + this.loadImgSize;
          let imgs = ([]).slice.call(document.querySelectorAll('.queue-load-img'), start, end);
          if (window.innerWidth >= 500) {
            imgs.forEach(img => {
              if (img) {
                img.src = img.getAttribute('data-src');
              }
            });
            this.loadImgCount++;
          }
          imgs = null;
        });
      },
      // 强制加载图片
      forceLoadImg () {
        clearTimeout(this.loadImgTimer);
        /* 在网速比较慢的情况下有可能会出现加载完3张图片后，其他图片就不会再加载了，为了防止这种情况就需要强制加载 */
        this.loadImgTimer = setTimeout(() => {
          let imgs = ([]).slice.call(document.querySelectorAll('.queue-load-img'));
          imgs.forEach(item => {
            if (!item.src) {
              item.src = item.getAttribute('data-src');
            }
          });
          clearTimeout(this.loadImgTimer);
          imgs = null;
        }, 15000);
      },
      imgLoadEvent () {
        this.loadedImgCount++;
        if (this.loadImgCount * this.loadImgSize === this.loadedImgCount) {
          this.loadImg();
        }
      },

    },
    computed: {
      ...mapGetters([getterTypes.Getter_Information_Nav]),
      // 控制左侧滑出菜单是否加载
      showLeftDrawer () {
        return this.$q.platform.is.mobile || window.innerWidth < 992;
      },
      menuData () {
        return this.Getter_Information_Nav;
      },
    },
    watch: {
      $route (newRoute) {
        if (newRoute.name === 'announcement' && newRoute.params.category !== this.category) {
          let pageData = this.pageData;
          this.category = newRoute.params.category;
          pageData.current = newRoute.params.current * 1 || 1;
          pageData.maxPages = 1;
          pageData.pageSize = newRoute.params.pageSize * 1 || 10;

          this.getNoticeList();
        }
      },
    },
    mounted () {
      // 如果是移动端，则不加载图片，节省带宽
      if (window.innerWidth >= 500) {
        this.showImg = true;
      }
      this.getNoticeList();
    },
    beforeDestroy () {
      clearTimeout(this.loadImgTimer);
    },
  };
</script>

<style lang="stylus" scoped>
  @import "../../../common/styles/mixin/two-column-mixin.styl";
  @import "./announcement.scoped.styl";
  announcement-pagination{
    .q-btn{
      min-height: 32px;
      box-shadow: none;
    }
  }
  .left-menu{
    position relative
  }
</style>

